export default __webpack_public_path__ + "a64871b1cb37c394d4baff688486a1af.png";